import React from "react"

const ChiWidget = () => {
  return (
    <iframe
      src="https://fluxfc.github.io/Rare-Chidesk/"
      style={{
        border: "0px",
        width: "100%",
        maxWidth: "700px",
        height: "700px",
        maxHeight: "100%",
        borderRadius: "8px", // Optional rounded corners
        backgroundColor: "transparent"
      }}
      name="booking-widget"
      scrolling="no"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      allowFullScreen
      title="ChiDesk Booking Widget"
    ></iframe>
  )
}

export default ChiWidget
